import React, { useEffect, useState } from 'react'
import Google from './Google'

function EmailLogin({source}) {
  const [sorceValue, setSourceValue] = useState('')
  useEffect(()=>{
    setSourceValue(source)
  },[source])
  return (
    <div className='text-center'>
      <div className="my-8 mx-auto flex justify-center items-center gap-3">
        <div className="h-[1px] w-1/4 bg-white"></div>
        <div className='whitespace-nowrap'>Or Login / Signup with</div>
        <div className="h-[1px] w-1/4 bg-white"></div>

      </div>

      <Google source={sorceValue}/>
    </div>
  )
}

export default EmailLogin